/**
 * Routine steps: each thumbnail opens its clip in a dialog. The video element is
 * built on open and torn down on close, so nothing downloads until asked for and
 * audio can't keep playing behind a closed dialog.
 */
class RoutineSteps extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!this.dialog) return;
    this.stage = this.dialog.querySelector('[data-video-stage]');
    this.caption = this.dialog.querySelector('[data-video-caption]');

    this.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-video]');
      if (trigger) {
        event.preventDefault();
        this.open(trigger);
        return;
      }
      if (event.target.closest('[data-close]')) this.dialog.close();
    });

    // Clicking the backdrop closes it, the way a lightbox is expected to behave.
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });

    this.dialog.addEventListener('close', () => this.teardown());
  }

  open(trigger) {
    const src = trigger.dataset.video;
    const poster = trigger.dataset.poster || '';
    if (!src) return;

    this.teardown();

    const video = document.createElement('video');
    video.src = src;
    video.controls = true;
    video.playsInline = true;
    video.autoplay = true;
    if (poster) video.poster = poster;
    this.stage.appendChild(video);

    if (this.caption) this.caption.textContent = trigger.dataset.label || '';

    if (typeof this.dialog.showModal === 'function') {
      this.dialog.showModal();
    } else {
      this.dialog.setAttribute('open', '');
    }

    const started = video.play();
    if (started && typeof started.catch === 'function') {
      // Autoplay can be refused; controls are on, so leave the first frame up.
      started.catch(() => {});
    }
  }

  teardown() {
    const video = this.stage.querySelector('video');
    if (!video) return;
    video.pause();
    video.removeAttribute('src');
    video.load();
    video.remove();
  }
}

if (!customElements.get('routine-steps')) {
  customElements.define('routine-steps', RoutineSteps);
}
